module.exports = __webpack_public_path__ + "img/profile.c150050c.jpg";